import { CampoSpecificoConservazioneVO } from "./campo-specifico-conservazioneVO";

export class TempiConservazioneVO {
  perSempre: boolean;
  // numeroAnniDaApertura: number;
  ereditaDaFascicolo: boolean;
  numeroAnniDaChiusura: number;
  campoSpecificoConservazione: CampoSpecificoConservazioneVO;
  motivazione: string;
}
